

























import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class PinIconV2 extends Vue {
  @Prop({ default: '14' }) readonly width?: string;
  @Prop({ default: '14' }) readonly height?: string;
  @Prop({ default: '#10222D' }) readonly fill?: string;
}
